export default __webpack_public_path__ + "static/media/m3_element_green.d818092d.png";